module.exports = __webpack_public_path__ + "img/symbol_6.c0ef8d70.png";